<!-- 地区选择弹窗 -->
<template>
  <el-dialog append-to-body
             title="自定义地区选择"
             :visible="dialogVisible"
             width="1103px"
             @close="handleDialogClose"
             @closeFn="closeFn">
    <div class="dialog-content">
      <city-popver-checkbox 
                            v-if="isShow"
                            @closeFn="closeFn"
                            v-bind="$attrs"
                            ref="cityPopverCheckbox"></city-popver-checkbox>
    </div>
  </el-dialog>
</template>

<script>
import CityPopverCheckbox from "./city-popver-checkbox";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CityPopverCheckbox
  },
  data() {
    return {
      dialogVisible: false,
      areaList: [],
      isShow:true
    };
  },

  created() {},

  methods: {
    closeFn(v) {
      if (v === 1) {
        // console.log(this.$refs.cityPopverCheckbox.getResult());
        this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult());
        this.$emit("input", false);
      } else {
        this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult(),'cancel');
        this.$emit("input", false);
      }
    },
    handleDialogClose(value) {
      // console.log(this.$refs.cityPopverCheckbox.getResult());
      this.$emit("on-change",this.$refs.cityPopverCheckbox.getResult(),'cancel');
      // this.$emit("on-change", this.$refs.cityPopverCheckbox.getResult()); // 没有数据也要传值回去,回显判断是否有数据，若无则地区选择为不限
      this.$emit("input", false);
      //this.$emit("input", value);
    }
  },

  watch: {
    value(value) {
      this.dialogVisible = value;
      this.isShow = value
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
